export interface ProgressHeadline {
  label: string;
  transient: boolean;
  planned: boolean;
}

export const PERSONALITY_MIN_VISIBLE_MS = 3500;

/** Pace presentation only. Keep the latest incoming status, never a stale queue.
 * Answers and attention states bypass the hold; callers keep recording real activity.
 */
export class ProgressHeadlineSequence {
  private current?: ProgressHeadline;
  private pending?: ProgressHeadline;
  private visibleUntil = 0;
  private timer?: ReturnType<typeof setTimeout>;

  constructor(private show: (headline: ProgressHeadline) => void, private now = () => Date.now()) {}

  update(next: ProgressHeadline, interrupt = false): void {
    if (!this.current || interrupt) { this.present(next); return; }
    if (this.current.label === next.label && this.current.transient === next.transient && this.current.planned === next.planned) {
      clearTimeout(this.timer); this.pending = undefined; return;
    }
    const remaining = this.visibleUntil - this.now();
    if (this.current.transient && remaining > 0) {
      this.pending = next;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { if (this.pending) this.present(this.pending); }, remaining);
    } else this.present(next);
  }

  private present(next: ProgressHeadline): void {
    clearTimeout(this.timer); this.pending = undefined;
    this.current = next;
    this.visibleUntil = this.now() + (next.transient ? PERSONALITY_MIN_VISIBLE_MS : 0);
    this.show(next);
  }

  dispose(): void {
    clearTimeout(this.timer); this.pending = undefined; this.current = undefined;
  }
}
